const cartPanelInner = document.querySelector('[data-mini-cart-panel-inner]')

export const getCart = (callback = null, buttonElement = null) => {
  fetch('/cart?view=inline')
    .then((response) => response.text())
    .then((cartResponse) => {
      cartPanelInner.innerHTML = new DOMParser()
        .parseFromString(cartResponse, 'text/html')
        .querySelector('[data-inline-cart]').innerHTML
      const cart = JSON.parse(cartPanelInner.querySelector('[data-cart-json]').innerHTML)
      if(buttonElement) {
        const innerHTML = buttonElement.innerHTML
        buttonElement.innerHTML = 'Item Added'
        setTimeout(() => {
          buttonElement.innerHTML = innerHTML
          buttonElement.disabled = false
        }, 2000)
      }
      if(cart.item_count == 0) Cookies.remove('gwp_remove')
      window.updateCartHead(cart)
      cartPanelInner.classList.remove('mini-cart--transition')
      window.setupGwp(document.querySelector('[data-cart-gwp]'), cart)


      // Init fit guide popup
      window.initFitGuide('[data-fancybox="product-fit-guide--cart"]', 'html')
      window.initFitGuide('[data-fancybox="product-fit-guide--inline-cart"]', 'html')

      if(callback) callback(cart)
    })
    .catch((e) => {
      console.error(e)
    })
}
window.getCart = getCart

export const addLineItems = (callback = null, items = [], buttonElement = null) => {
  cartPanelInner.classList.add('mini-cart--transition')
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': items
    })
  })
  .then(response => {
    return response.json()
  })
  .then(response => {
    console.log(response)
    getCart(callback, buttonElement)
  })
  .catch((error) => {
    console.error('Error:', error)
    getCart(callback, buttonElement)
  })
}
window.addLineItems = addLineItems

// export const makeLineItem = (variantId, quantity, tags) => {
//   const properties = {}
//   if(tags.includes('Final Sale')) properties['Final Sale'] = 'Yes'
//   if(tags.includes('pre-order')) {
//     let deliveryTag = null
//     tags.forEach((tag) => {
//       if(tag.includes('delivery_')) deliveryTag = tag
//     })
//     if(deliveryTag) properties['Expected Ship Date'] = deliveryTag.replace('delivery_', '').replaceAll('/', '-')
//   }
//   return {
//     id: variantId,
//     quantity,
//     properties,
//   }
// }
// window.makeLineItem = makeLineItem

export const changeLineItem = (callback = null, item = {}) => {
  cartPanelInner.classList.add('mini-cart--transition')
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  })
  .then(response => {
    return response.json()
  })
  .then(cart => {
    console.log(cart)
    getCart(callback)
  })
  .catch((error) => {
    console.error('Error:', error)
    getCart(callback)
  })
}
window.changeLineItem = changeLineItem

export const updateLineItems = (callback = null, updates = {}) => {
  cartPanelInner.classList.add('mini-cart--transition')
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json()
  })
  .then(cart => {
    console.log(cart)
    getCart(callback)
  })
  .catch((error) => {
    console.error('Error:', error)
    getCart(callback)
  })
}
window.updateLineItems = updateLineItems